module.exports = __webpack_public_path__ + "img/png_title3.93120afb.png";